import { createUseStyles } from 'react-jss'

import { backgroundGrey, darkGrey } from './const/colors'

const useMainStyles = createUseStyles(theme => {
  return {
    '@global': {
      html: {
        fontFamily: theme.fontFamily.value,

        '@global': {
          '@font-face': [
            {
              fontFamily: `${theme.fontFamily.name}`,
              src: `url("${theme.fontFamily.normal}") format('${theme.fontFamily.format}')`,
              fontWeight: 400,
              fontStyle: 'normal',
              fontDisplay: 'swap'
            },
            {
              fontFamily: `${theme.fontFamily.name}`,
              src: `url("${theme.fontFamily.medium}") format('${theme.fontFamily.format}')`,
              fontWeight: 600,
              fontStyle: 'normal',
              fontDisplay: 'swap'
            },
            {
              fontFamily: `${theme.fontFamily.name}`,
              src: `url("${theme.fontFamily.bold}") format('${theme.fontFamily.format}')`,
              fontWeight: 700,
              fontStyle: 'normal',
              fontDisplay: 'swap'
            }
          ]
        }
      },
      body: {
        minHeight: '100vh',
        backgroundColor: backgroundGrey
      },
      'h1, h2, h3, h4, h5, h6': {
        fontWeight: 700,
        margin: 0,
        fontSize: '14px'
      },
      h1: {
        fontSize: '18px',
        lineHeight: '22px'
      },
      h2: {
        fontSize: '16px',
        lineHeight: '19px'
      },
      'input, textarea, select, button': {
        fontFamily: "'Lato', sans-serif"
      },
      '@media screen and (max-width: 767px)': {
        html: {
          fontSize: '12px'
        }
      },
      'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active':
        {
          '-webkit-box-shadow': '0 0 0 30px white inset !important',
          '-webkit-text-fill-color': `${darkGrey} !important`
        },
      '.rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span, .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span, .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span, .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span':
        {
          color: darkGrey
        },
      '.rdrDateDisplayItem, .rdrMonthAndYearPickers select, .rdrNextPrevButton, .rdrDayToday .rdrDayNumber span:after, .rdrSelected, .rdrDayStartOfMonth .rdrEndEdge, .rdrDayStartOfWeek .rdrEndEdge, .rdrDayEndOfMonth .rdrStartEdge, .rdrDayEndOfWeek .rdrStartEdge, .rdrDayStartOfMonth .rdrDayInPreview, .rdrDayStartOfMonth .rdrDayEndPreview, .rdrDayStartOfWeek .rdrDayInPreview, .rdrDayStartOfWeek .rdrDayEndPreview, .rdrDayEndOfMonth .rdrDayInPreview, .rdrDayEndOfMonth .rdrDayStartPreview, .rdrDayEndOfWeek .rdrDayInPreview, .rdrDayEndOfWeek .rdrDayStartPreview, .rdrDayStartPreview, .rdrDayEndPreview, .rdrInputRangeInput, .rdrCalendarWrapper:not(.rdrDateRangeWrapper) .rdrDayHovered .rdrDayNumber:after':
        {
          borderRadius: '4px'
        },
      '.rdrStartEdge, .rdrDayStartOfMonth .rdrInRange, .rdrDayStartOfMonth .rdrEndEdge, .rdrDayStartOfWeek .rdrInRange, .rdrDayStartOfWeek .rdrEndEdge':
        {
          borderTopLeftRadius: '4px',
          borderBottomLeftRadius: '4px'
        },
      '.rdrEndEdge, .rdrDayEndOfMonth .rdrInRange, .rdrDayEndOfMonth .rdrStartEdge, .rdrDayEndOfWeek .rdrInRange, .rdrDayEndOfWeek .rdrStartEdge':
        {
          borderTopRightRadius: '4px',
          borderBottomRightRadius: '4px'
        },
      '.rdrDayToday:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span:after, .rdrDayToday:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span:after, .rdrDayToday:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span:after, .rdrDayToday:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span:after':
        {
          backgroundColor: darkGrey
        }
    }
  }
})

export default useMainStyles
